import { DateTime } from 'luxon';
import { DATE_YYYY_MM_DD, TIME_HH_MM_SS } from '../../constants/dateTimes';
import { UTC } from '../../constants/timezones';

export default function getOpenHouseDateTimeFromRepliersTREBInfo(
  openHouseDateString: string, // Format: '2022-08-06 00:00:00.0'
  openHouseTimeString: string, // Format: '1:00 PM'
  listingTimezone: string, // Format: 'America/Toronto'
): DateTime {
  const dateString = DateTime.fromSQL(openHouseDateString, {
    zone: UTC,
  }).toFormat(DATE_YYYY_MM_DD);

  const timeString = DateTime.fromFormat(
    openHouseTimeString,
    'h:mm a',
  ).toFormat(TIME_HH_MM_SS);

  return DateTime.fromISO(`${dateString}T${timeString}`, {
    zone: listingTimezone,
  }).toUTC();
}
